export const CITY_NAME_ENDPOINT = "https://hikkoshi-mitsumori.site/api/city-name/"

export const DISTANCE_ENDPOINT = "https://hikkoshi-mitsumori.site/api/distance/"

export const FURNITURES_ENDPOINT = "https://hikkoshi-mitsumori.site/api/furnitures/"

export const CONTRACT_ENDPOINT = "https://hikkoshi-mitsumori.site/api/contract/"

export const OPTION_ENDPOINT = "https://hikkoshi-mitsumori.site/api/option/"